import axios from 'axios';

var FavoritesServerActions = require('../actions/favorites-server-actions');
var UserServerActions = require('../actions/user-server-actions');

var FavoritesAPIUtils = {

  add: function(placeId) {
    axios.put('/api/favorites/' + placeId).then(response => {
      FavoritesServerActions.added(placeId);
    })
      .catch(response => {
        if (response.status === 401) {
          UserServerActions.loginRequired();
        }
      });
  },

  remove: function(placeId) {
    axios.delete('/api/favorites/' + placeId).then(function(response){
      FavoritesServerActions.removed(placeId);
    });
  },

  getAllFavorites: function() {
    axios.get('/api/favorites').then(function(response){
      FavoritesServerActions.receivedAll(response.data);
    });
  }


};

module.exports = FavoritesAPIUtils;



// WEBPACK FOOTER //
// ./utils/favorites-api.js